"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _portal = require("@gorhom/portal");
var _A11yInfoProvider = _interopRequireDefault(require("../A11yInfoProvider"));
var _ViewportProvider = _interopRequireDefault(require("../ViewportProvider"));
var _ThemeProvider = _interopRequireDefault(require("../ThemeProvider"));
var _HydrationContext = require("./HydrationContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// eslint-disable-next-line no-unused-vars
const BaseProvider = /*#__PURE__*/_react.default.forwardRef((_ref, _) => {
  let {
    defaultTheme,
    children,
    themeOptions
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_HydrationContext.HydrationProvider, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A11yInfoProvider.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ViewportProvider.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThemeProvider.default, {
          defaultTheme: defaultTheme,
          themeOptions: themeOptions,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_portal.PortalProvider, {
            children: children
          })
        })
      })
    })
  });
});
BaseProvider.displayName = 'BaseProvider';
BaseProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  defaultTheme: _ThemeProvider.default.propTypes?.defaultTheme,
  themeOptions: _propTypes.default.shape({
    forceAbsoluteFontSizing: _propTypes.default.bool,
    forceZIndex: _propTypes.default.bool
  })
};
var _default = exports.default = BaseProvider;